/** Stable, path-safe and collision-free for opaque account ids. Never use an email or token. */
export function storageScope(userId) {
    return userId === null
        ? 'guest'
        : `account-${encodeURIComponent(userId).replace(/[._%]/g, (character) => `_${character.charCodeAt(0).toString(16)}`)}`;
}
/** Older local documents have no authenticated owner; keep them in the device library. */
export function legacyOwner(value) {
    if (typeof value !== 'object' ||
        value === null ||
        !('ownerId' in value) ||
        typeof value.ownerId !== 'string')
        return null;
    return ['local', 'user_local', ''].includes(value.ownerId) ? null : value.ownerId;
}
//# sourceMappingURL=storage-scope.js.map